import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { messageSendRequest, messageSendSuccess, messageSendFailure } from '../reducers/message';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/message`;

function* messageSendFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId: senderId, isTeamLeader },
    token,
  } = state.loginReducer;
  const { userId: recipientId } = state.connectedUsersReducer.recipient;
  const {
    messageData: { message, subject, status },
    attachment,
    typeId,
  } = state.messageReducer;
  // https://wiki.opinov8.com/display/DF/Messages+-+Technical
  const LEVEL = 2; // the level of the message, for this phase only 2 will be required
  const { selectedThinkToolId } = state.teamMembersFullReducer;
  const { selectedContentId } = state.userProgramsFullReducer;
  const contentId = isTeamLeader ? selectedThinkToolId : selectedContentId;

  const formData = new FormData();
  
  if (attachment !== null && attachment.length) {
    attachment.forEach(att => {
      formData.append('attachment', att, att.name.split(' ').join('_'));
    });
  }
  formData.append('message', message);
  formData.append('senderId', senderId);
  formData.append('recipientId', recipientId);
  formData.append('contentId', contentId);
  formData.append('levelId', LEVEL);
  formData.append('typeId', typeId);
  formData.append('subject', subject);
  formData.append('status', status);

  const response = yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: formData,
    }),
  );

  return response;
}

function* workerMessageSendSaga() {
  try {
    const response = yield call(messageSendFunctionAxios);
    const responseFromSendMessage = response.data;

    if (response.status === 200) {
      yield put(messageSendSuccess(responseFromSendMessage));
    }

    if (response.status === 203) {
      yield put(messageSendFailure('message does not exist'));
    }

    if (response.status === 500) {
      yield put(messageSendFailure(response.statusText));
    }
  } catch (error) {
    yield put(messageSendFailure(error));
  }
}

export function* watcherMessageSendSaga() {
  yield takeLatest(messageSendRequest().type, workerMessageSendSaga);
}
